// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1Gbuj","modalFooterButton":"ModalNotes_modalFooterButton__4AOok"};